import { Component, AfterViewInit } from '@angular/core';
import { ServiceBagService } from '@base/component/ServiceBag';
import { BaseEntity, BaseState } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { SysGlobals } from '@core/framework/sysglobals';


@Component({
    selector: 'm4u-comingsoon',
    templateUrl: './comingsoon.component.html',
    styleUrls: ['./comingsoon.component.scss']
})
export class ComingSoonComponent extends BasePageComponent<BaseEntity, BaseState> implements AfterViewInit
{
    constructor(A: ServiceBagService) 
    {
        super(A, 'ComingSoonComponent', BaseEntity, BaseState);
    }

    override ngAfterViewInit()
    {
        setTimeout(() => { this.Navigate(['/pages/dashboard'], { Language: SysGlobals.Language }); }, 4000);
    }
}
